import React, {createElement, useEffect, useState} from 'react';
import { Table, Divider, Spin} from "antd";
import {summaryColumnData} from'./columns';
import {getGridTableHeight, getAssetTypeTitle, amountFormatter, floatFormatter} from '../Common/util';
import {Chart01, Chart02, Chart03} from './Chart';

/** -------------------------------------------------------------------------- **/
function Summary({assetType, measureList, assetList, sumData, spinflag}) {
    // const [spinflag, setSpinflag] = useState(true);
    // window.onload = ()=>{
    //   setSpinflag(false);
    // }
    return (
        <Spin size={"large"}  tip={"Loading..."} spinning={spinflag}>
            <div id="divTabs1" className="section" style={{height:getGridTableHeight(210), overflowY:'auto'}}>
                <div className="sub_title">
                        {'■ 진단 영역별 보안수준'}
                </div>
                <div style={{padding: '5px 10px'}}>
                    <Table 
                        columns={summaryColumnData}
                        dataSource={measureList}
                        scroll={{y: 280}}
                        pagination={false}
                        bordered size={"small"}
                        className="sub_table"
                        rowKey='code'
                        summary={() => {
                          
                            return (
                              <>
                                <Table.Summary.Row>
                                  <Table.Summary.Cell index={0} colSpan={2}>{'보안수준(%)=평가점수/전체점수'}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={2}>{amountFormatter(sumData.total)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={3}>{amountFormatter(sumData.check)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={4}>{amountFormatter(sumData.Y)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={5}>{amountFormatter(sumData.N)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={6}>{amountFormatter(sumData.P)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={7}>{amountFormatter(sumData.NA)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={8}>{amountFormatter(sumData.total_score)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={9}>{amountFormatter(sumData.eval_score)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={10}>{floatFormatter(sumData.level,1)}%</Table.Summary.Cell>
                                </Table.Summary.Row>
                              </>
                            );
                        }}
                        >
                    </Table>
                </div>
                <Divider />
                <div className="sub_title">
                        {'■ ' + getAssetTypeTitle(assetType) + ' 보안수준'}
                </div>
                <div style={{padding: '5px 10px', height: '200px'}}>
                    <Chart01 dataList={measureList} sumData={sumData} />
                </div>
                <div style={{padding: '5px 10px', height: '400px'}}>
                    <Chart02 dataList={measureList} sumData={sumData} />
                </div>
                <Divider />
                <div className="sub_title">
                        {'■ 장비별 보안수준'}
                </div>
                <div style={{padding: '5px 10px'}}>
                    <Table 
                        columns={summaryColumnData}
                        dataSource={assetList}
                        pagination={false}
                        bordered size={"small"}
                        className="sub_table"
                        rowKey='code'
                        summary={(assetList) => {
                          const s_total_score = assetList.reduce( (acc, curr) => acc + curr.total_score,0 );
                          const s_eval_score = assetList.reduce( (acc, curr) => acc + curr.eval_score,0 );
                          const s_level = (s_eval_score /  s_total_score) * 100;
                          return (
                            <>
                              <Table.Summary.Row>
                                <Table.Summary.Cell index={0} colSpan={2}>{'보안수준(%)=평가점수/전체점수'}</Table.Summary.Cell>
                                <Table.Summary.Cell index={2}>{amountFormatter(assetList.reduce( (acc, curr) => acc + curr.total,0))}</Table.Summary.Cell>
                                <Table.Summary.Cell index={3}>{amountFormatter(assetList.reduce( (acc, curr) => acc + curr.check,0))}</Table.Summary.Cell>
                                <Table.Summary.Cell index={4}>{amountFormatter(assetList.reduce( (acc, curr) => acc + curr.Y,0))}</Table.Summary.Cell>
                                <Table.Summary.Cell index={5}>{amountFormatter(assetList.reduce( (acc, curr) => acc + curr.N,0))}</Table.Summary.Cell>
                                <Table.Summary.Cell index={6}>{amountFormatter(assetList.reduce( (acc, curr) => acc + curr.P,0))}</Table.Summary.Cell>
                                <Table.Summary.Cell index={7}>{amountFormatter(assetList.reduce( (acc, curr) => acc + curr.NA,0))}</Table.Summary.Cell>
                                <Table.Summary.Cell index={8}>{amountFormatter(s_total_score)}</Table.Summary.Cell>
                                <Table.Summary.Cell index={9}>{amountFormatter(s_eval_score)}</Table.Summary.Cell>
                                <Table.Summary.Cell index={10}>{floatFormatter(s_level,1)}%</Table.Summary.Cell>
                              </Table.Summary.Row>
                            </>
                          );
                      }}
                      >
                  </Table>
                </div>
                <Divider />
                <div className="sub_title">
                        {'■ ' + getAssetTypeTitle(assetType) + ' 대상별 보안수준'}
                </div>
                <div style={{padding: '5px 10px', height: '250px'}}>
                    <Chart03 dataList={assetList} sumData={sumData} />
                </div>
            </div>
        </Spin>
    );
}
export default Summary;